// resources-filter.js

jQuery(document).ready(function ($) {
  const searchInput = $('#resource-search');
  const searchBtn = $('#resource-search-btn');

  function performSearch() {
    const searchTerm = searchInput.val().trim();

    const url = new URL(window.location.href);

    // Reset pagination when performing a new search
    // Example:
    // /resource/page/2/ -> /resource/
    // /resource-type/bike-maps/page/3/ -> /resource-type/bike-maps/
    url.pathname = url.pathname.replace(/\/page\/\d+\/?$/, '/');

    // Set/remove search parameter
    if (searchTerm) {
      url.searchParams.set('search', searchTerm);
    } else {
      url.searchParams.delete('search');
    }

    // Navigate
    window.location.href = url.toString();
  }

  // Search button click
  searchBtn.on('click', function (e) {
    e.preventDefault();
    performSearch();
  });

  // Enter key
  searchInput.on('keypress', function (e) {
    if (e.which === 13) {
      e.preventDefault();
      performSearch();
    }
  });
});
